"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var MigrateIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(MigrateIcon, _React$PureComponent);

  function MigrateIcon() {
    _classCallCheck(this, MigrateIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(MigrateIcon).apply(this, arguments));
  }

  _createClass(MigrateIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'migrate-icon')
      }, props), _react.default.createElement("g", null, _react.default.createElement("rect", {
        fill: color,
        x: "0",
        y: "1",
        rx: "1",
        width: "2",
        height: "10"
      }), _react.default.createElement("rect", {
        fill: color,
        x: "10",
        y: "1",
        rx: "1",
        width: "2",
        height: "10"
      }), _react.default.createElement("rect", {
        fill: color,
        x: "3",
        y: "5",
        rx: "1",
        width: "4",
        height: "2"
      }), _react.default.createElement("path", {
        fill: color,
        d: "M5.00010191,3.66976746 L5.00038631,8.32938131 C5.0004116,8.74359487 5.33621853,9.07936081 5.75043209,9.07933553 C5.93417388,9.07932431 6.11151889,9.01186341 6.24881523,8.88975378 L8.86956362,6.55889327 C9.17907407,6.28361858 9.20682764,5.80955656 8.93155296,5.5000461 C8.91203255,5.47809795 8.89123964,5.4573155 8.86928167,5.43780613 L6.24824888,3.1090528 C5.93860001,2.83393382 5.464552,2.86192584 5.18943303,3.17157471 C5.06745786,3.30885887 5.00009071,3.48612411 5.00010191,3.66976746 Z"
      })));
      /* eslint-enable max-len */
    }
  }]);

  return MigrateIcon;
}(_react.default.PureComponent);

exports.default = MigrateIcon;
MigrateIcon.defaultProps = {
  color: 'inherit'
};
MigrateIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};